export default "__VITE_ASSET__CRJzpgIC__"